module.exports = "https://web-assets.ifttt.com/packs/media/docs/create-connection-ce13d502.png";